import { render, staticRenderFns } from "./activityMList.vue?vue&type=template&id=15ef8a66&scoped=true&"
import script from "./activityMList.vue?vue&type=script&lang=js&"
export * from "./activityMList.vue?vue&type=script&lang=js&"
import style0 from "./activityMList.vue?vue&type=style&index=0&id=15ef8a66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef8a66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ef8a66')) {
      api.createRecord('15ef8a66', component.options)
    } else {
      api.reload('15ef8a66', component.options)
    }
    module.hot.accept("./activityMList.vue?vue&type=template&id=15ef8a66&scoped=true&", function () {
      api.rerender('15ef8a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/activityManage/activityList/activityMList.vue"
export default component.exports